<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { Invoice } from '../../../../Types/invoice'

defineProps<{
  invoices: Invoice[]
}>()

const { d, n, t } = useI18n()
</script>

<template>
  <div class="table-responsive">
    <table class="table table-striped mb-0">
      <thead>
        <tr>
          <th class="font-weight-bold col-2">{{ t('invoice.label.creditNumber') }}</th>
          <th class="font-weight-bold col-4">{{ t('invoice.label.createdAt') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.status') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.tax') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.amount') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="invoice in invoices" :key="invoice.id">
          <td>{{ invoice.number }}</td>
          <td>{{ invoice.createdAt ? d(new Date(invoice.createdAt), 'date') : '-' }}</td>
          <td>{{ t('invoice.status.' + invoice.status + '.label') }}</td>
          <td>{{ invoice.vatAmount ? n(Number(invoice.vatAmount), 'currency') : '-' }}</td>
          <td>{{ invoice.amount ? n(Number(invoice.amount), 'currency') : '-' }}</td>
        </tr>
        <tr v-if="!invoices?.length">
          <td colspan="5" class="text-center">
            {{ t('invoice.title.emptyCreditNotes') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
